const { Fragment, useEffect, useState } = wp.element;
const { __ } = wp.i18n;
const { MediaUpload, MediaUploadCheck } = wp.blockEditor;
const { Button, Placeholder } = wp.components;
// import BPlayer from "../../public/BPlayer";
// import Player from "../Components/Player";
import BSettings from "./../Components/BSettings";
// import PremiumPopup from "../Components/premiumPopop";
// import RefactorDataStructure from "../Components/RefactorDataStructure";
import VideoPlayer from "../../components/VideoPlayer";
import { isYoutubeURL } from "../../../../wp-utils/v1";

const Edit = (props) => {
  const [isPremium, setIsPremium] = useState(h5vpBlock?.isPipe);
  const { attributes, setAttributes, isSelected } = props;

  const { source } = attributes;

  const [mediaSource, setMediaSource] = useState();
  const [valid, setValid] = useState(true);

  useEffect(() => {
    setIsPremium(h5vpBlock?.isPipe == 1);
    // setTimeout(() => {
    //   if (!isPremium) {
    //     wp.blocks.unregisterBlockType("html5-player/youtube");
    //   }
    // }, 2000);
  }, []);

  useEffect(() => {
    if (isSelected) {
      wp.data.dispatch("core/edit-post").openGeneralSidebar("edit-post/block");
    }
  }, [isSelected]);

  const handleApply = (event) => {
    event.preventDefault();
    if (!isYoutubeURL(mediaSource)) {
      setValid(false);
      return false;
    }
    // createVideo();
    setValid(true);
    setAttributes({ source: mediaSource });
    setMediaSource("");
  };

  return (
    <Fragment>
      {/* {!h5vpBlock?.isPipe && <PremiumPopup />} */}

      {!isSelected && <div className="item_selected"></div>}
      {source ? (
        <Fragment>
          <BSettings {...props} isPremium={isPremium} />
          {/* <Player classes={classes} attributes={attributes} /> */}
          {isPremium ? <VideoPlayer attributes={attributes} isSelected={isSelected} /> : <h2 className="text-danger">{__("sorry, it's a premium feature", "h5vp")}</h2>}
        </Fragment>
      ) : (
        <Fragment>
          <Placeholder
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="html5-block-icon"
              >
                <polygon points="23 7 16 12 23 17 23 7"></polygon>
                <rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect>
              </svg>
            }
            instructions={__("Upload a video or paste/write video url to get started.", "h5vp")}
            label={__("Upload a Video ", "h5vp")}
          >
            <div className="h5vpUrlInput">
              <input
                type="url"
                aria-label={__("URL", "h5vp")}
                placeholder={__("Paste or type a youtube video URL", "h5vp")}
                onChange={(src) => {
                  setValid(true);
                  setMediaSource(src.target.value);
                }}
                value={mediaSource}
              />
              <Button label={__("Apply", "h5vp")} type="submit" onClick={handleApply} isPrimary>
                {__("Apply", "h5vp")}
              </Button>
            </div>
            {!valid && <p style={{ color: "#bd1818", width: "100%", margin: 0 }}>{__("URL is not valid", "h5vp")}</p>}
          </Placeholder>
        </Fragment>
      )}
    </Fragment>
  );
};

export default Edit;
